import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Image } from 'components';
import { linksSocialApp } from '../constants';

import styles from './styles.module.scss';

export const LinksPlatformsFooter = memo(() => {
  const { t } = useTranslation('footer');

  return (
    <div className={styles.footer_platforms}>
      {linksSocialApp.map(({ icon, title }, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={styles.footer_social_link}
        >
          <Image
            url={icon}
            className={styles.footer_social_link_icon}
          />
          <p className={styles.footer_social_link_text}>
            {t(title)}
          </p>
        </div>
      ))}
    </div>
  );
});
